import { createStore } from "owa-satcheljs";
import type MailOrganizationViewTypes from "./schema/MailOrganizationViewTypes";
import type ViewType from "./schema/ViewType";

interface MailOrganizationSettingsStore extends MailOrganizationViewTypes {
    nonWin32StyleReadingPaneViewType: ViewType | null;
    isClassicIndentedView: boolean | null;
}

const defaultExport: () => MailOrganizationSettingsStore = createStore<MailOrganizationSettingsStore>("mailOrganizationSettingsStore", {
    messageListExpansionType: 3,
    readingPaneViewType: 3,
    nonWin32StyleReadingPaneViewType: null,
    isClassicIndentedView: null,
});
export default defaultExport;
